// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"VWbdrW1_0UVmVDL2JHlu"};